import { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const BucketsGetPage = inject("mainStore")(
    observer(({ mainStore }) => {
        const [bucket, setBucket] = useState([]);
        const [data, setData] = useState({ bucketCode: null, count: null });

        useEffect(() => {
            getBuckets();
        }, []);

        const getBuckets = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1&project[name]=1&project[archived]=1&sortField=name&sortOrder=asc", false, "", false, false);
            if (resp && resp.success) {
                setBucket(resp.data);
            }
        };

        const renderTitle = (item) => {
            return (
                <span>
                    {item.blockTitle.name}
                    {item.blockSub && <span style={item.blockSub?.style}>{item.blockSub?.name}</span>}
                </span>
            );
        };

        const getPromoHandler = async () => {
            const resp = await mainStore.getByUrl(`/promo/getSomePromoFromBucket?bucketCode=${data.bucketCode}&count=${data.count}`, false, "", false, false);
            if (resp && typeof resp != "object") {
                const blob = new Blob([resp]);
                const fileName = `codes`;
                const elem = window.document.createElement("a");
                elem.href = window.URL.createObjectURL(blob);
                elem.download = fileName;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
                mainStore.setMainStore("toast", { severity: "success", summary: `Промокоды успешно получены` });
                setData({ bucketCode: null, count: null });
            }
        };

        return (
            <div className="buckets__get">
                <Card className="buckets__block" title={renderTitle({ blockTitle: { name: "Корзины / " }, blockSub: { name: "Достать", style: { color: "#9E9E9E" } } })}>
                    <div className="buckets__form">
                        <div className="wrapper">
                            <label className="label">Корзина с промокодами*</label>
                            <Dropdown
                                value={data.bucketCode}
                                onChange={(e) => {
                                    setData((prev) => {
                                        return { ...prev, bucketCode: e.value };
                                    });
                                }}
                                options={bucket ? bucket : []}
                                optionLabel="title"
                                optionValue="code"
                                placeholder="Выберите из списка"
                                className="dropdown"
                                filter
                            />
                        </div>

                        <div className="wrapper">
                            <label className="label">Количество (макс. 50 000)*</label>
                            <InputNumber
                                value={data.count}
                                onChange={(e) =>
                                    setData((prev) => {
                                        return { ...prev, count: e.value };
                                    })
                                }
                                max="50000"
                            />
                        </div>
                    </div>

                    <ButtonUI severity="success" label="Выгрузить файлы" icon="pi pi-download" disabled={!data.bucketCode || !data.count} onClick={getPromoHandler} />
                </Card>
            </div>
        );
    }),
);

export default BucketsGetPage;
